import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonMaterialModule } from '@nrwl/common-material';
import { ViewMapModule } from '@nrwl/view-map';
import { CommonLibModule, TimeoutWrapper } from '@nrwl/common-lib';
import { ViewTableModule } from '@nrwl/view-table';

import { ApplicationsEntityWidgetComponent } from './components/applications.entity.widget/applications.entity.widget.component';
import { ApplicationsDetailsWidgetComponent } from './components/applications.details.widget/applications.details.widget.component';
import { ApplicationsPageComponent } from './components/applications.page/applications.page.component';
import { MonitorManagementModule } from '@nrwl/monitor-management';
import { ViaviTabulatorModule } from '@nrwl/viavi-tabulator';
import { AddScriptPopupComponent } from './components/script-editor/add-script-popup/add-script-popup.component';
import { SaveScriptDialogComponent } from './components/script-editor/save-script-dialog/save-script-dialog.component';
import { SaveScriptService } from './components/script-editor/save-script-dialog/save-script.service';
import { PrecheckScriptDialogComponent } from './components/script-editor/precheck-script-dialog/precheck-script-dialog.component';
import { TestListTableComponent } from '@nrwl/test-list-management';

@NgModule({
  imports: [
    CommonModule,
    CommonMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ViewMapModule,
    ViewTableModule,
    CommonLibModule,
    MonitorManagementModule,
    ViaviTabulatorModule,
    TestListTableComponent
  ],
  declarations: [
    ApplicationsEntityWidgetComponent,
    ApplicationsDetailsWidgetComponent,
    ApplicationsPageComponent,
    AddScriptPopupComponent,
    SaveScriptDialogComponent,
    PrecheckScriptDialogComponent
  ],
  providers: [TimeoutWrapper, SaveScriptService],
  exports: [ApplicationsEntityWidgetComponent, ApplicationsPageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApplicationManagementModule {}
